var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.flagComponent,_vm._b({tag:"component",class:_vm.sizeClass,attrs:{"role":"img"}},'component',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }